<template>
  <div class="h-full min-h-screen md:min-h-0 flex flex-col login">
    <NavMenu />
    <div
      :class="themeIsDark ? 'bg-black text-white' : 'bg-white text-black'"
      class="flex-1 md:overflow-y-scroll px-10 pt-20 pb-72"
    >
      <div class="mb-24">
        <Icon id="spotifyBig" />
      </div>
      <p
        class="text-terms text-sm text-center md:text-left md:w-134 m-auto"
        v-html="$t('loginText')"
      ></p>
    </div>
    <div>
      <div
        :class="themeIsDark ? 'bg-black text-white' : 'bg-white text-black'"
        class="p-10 fixed left-0 md:absolute bottom-0 w-full"
      >
        <div class="mb-8">
          <LoginButton />
        </div>
        <span
          role="button"
          class="text-base text-center block"
          @click="skip"
        >
          {{ $t("loginSkip") }}
        </span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import cms from '@/cms'
import { RouteGuardHandler } from '../../mixins/route-guard-handler'
import { TranslationHandler } from '../../mixins/translation-handler'
import { Component, Mixins } from 'vue-property-decorator'
import { Action, Getter } from 'vuex-class'
import LoginButton from '@/app/components/LoginButton.vue'

@Component({
  components: {
    LoginButton
  }
})
export default class Login extends Mixins(TranslationHandler, RouteGuardHandler) {
  @Getter campaignId!: number
  @Getter isAuthenticated!: boolean

  @Getter themeIsDark!: boolean
  @Getter themePrimaryColor!: string
  @Getter themeLogoImageUrl!: string

  @Action('GO_TO_NEXT_STEP') goToNextStep!: () => void
  @Action('ENSURE_STEP_NAME') ensureStepName!: (stepName: string) => void

  beforeMount () {
    console.log('Is authenticated?', this.isAuthenticated)
    this.ensureStepName('Login')
    if (this.isAuthenticated) {
      this.goToNextStep()
    }
  }

  skip () {
    cms.tracking.trackCustomer('login_skip')
    this.goToNextStep()
  }
}
</script>

<style lang="scss" scoped>
::v-deep .text-terms {
  a {
    text-decoration: underline;
  }
}
</style>
